import { ISendEmailRequisicaoCompraUseCase } from "../../../presentation/useCases/read/send_email_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * SendEmailRequisicaoCompraUseCase
 */

export class SendEmailRequisicaoCompraUseCase implements ISendEmailRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async sendEmailRequisicaoCompra(
    idRequisicaoCompra: number,
    subject: string,
    sendTo: string,
    body: string,
    attachment: string,
  ): Promise<void> {
    const emails = sendTo.split(';');

    emails.forEach(e => e.trim());

    await this.repository
      .sendEmailRequisicaoCompra(
        idRequisicaoCompra,
        subject,
        emails,
        body,
        attachment,
      );
  }
}
